import {
  createRootRouteWithContext,
  Outlet,
  HeadContent,
  Scripts,
} from "@tanstack/react-router";

type UseAuthReturn = ReturnType<typeof import("@/lib/Auth/useAuth").useAuth>;

// Only `auth` is genuine outside-the-router context (AuthProvider sits above
// RouterProvider). The org/supplier scope lives in the URL params and is read
// via `params` in loaders and `useParams` in components — never duplicated here.
interface MyRouterContext {
  auth: UseAuthReturn;
}

function RootComponent() {
  return (
    <>
      <HeadContent />
      <Outlet />
      <Scripts />
    </>
  );
}

export const rootRoute = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      {
        name: "description",
        content: "Imoova Admin - Vehicle Relocation Marketplace",
      },
    ],
  }),
});
